module.exports = __webpack_public_path__ + "static/img/logo_fpt.726ff54.png";


//////////////////
// WEBPACK FOOTER
// ./src/customization/SteelOApp/pages/Login/Assets/Img/logo_fpt.png
// module id = 6zy7
// module chunks = 0